
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { Currency, Insurance, Procedure } from '../../../models/backend-definitions.module';
import { PageOptions } from '../../../util/backend-util-module';

@Injectable()
export class CurrencyListProvider implements Resolve<any> {
    currency: Currency[];
    currencyEdit: Currency;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.currencyEdit = this.state?.currentCurrency;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<Currency> {
        if (!id) {
            return null;
        }
        return this.gw.get('currency/:id', { id: id });
    }

    get currentCurrency(): Currency {
        return this.currencyEdit;
    }

    getGroup(id: number): Observable<HttpResponse<any>> {
        if (!id) {
            return null;
        }
        return this.gw.get('currency/group/wAll/:id', { id: id });
    }

    getProcedure(id: number): Observable<HttpResponse<Procedure>> {
        if (!id) {
            return null;
        }
        return this.gw.get('currency/procedure/:id', { id: id });
    }

    getInsurance(id: number): Observable<HttpResponse<Insurance>> {
        if (!id) {
            return null;
        }
        return this.gw.get('currency/insurance/:id', { id: id });
    }

    getAll(entity?: String): Promise<any> {
        let path;
        if (entity) {
            path = entity + 'currency/'
        } else {
            path = 'currency/';
        }
        return new Promise((resolve, reject) => {
            this.gw.get(path).subscribe((res: HttpResponse<any>) => {
                this.currency = res.body;
                this.onDataChanged.next(this.currency);
                resolve(res);
            }, reject);
        });
    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('currency/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.currency, res.body.content) && res.body.content.length > 0) {
                    this.currency = res.body.content;
                    this.onDataChanged.next(this.currency);
                } else {
                    this.currency = res.body.content;
                }
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

